import { api_GET, api_GET_Unauthorize, api_POST, api_POST_files_Unauthorize, api_POST_Unauthorize, api_PUT } from './_api';
import { getSessionCookie } from "../helpers/cookies.js";

const gerador_api = {
    GetList: (prefeitura_id = 0) => {
        const promise = new Promise((resolve, reject) => {
            const session = getSessionCookie();

            if (session.acesso.modulo === "Destino" || session.acesso.modulo === "Fiscal")
                session.acesso.modulo = "Gestor"

            api_GET(`Gerador/${session.acesso.modulo}/GetList/${prefeitura_id}`)
                .then(result => {
                    resolve(result);
                }).catch(e => {
                    reject(e);
                });
        });
        return promise;
    },
    GetListSemContrato: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Gerador/GetListSemContrato/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetModalidadesContratos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Gerador/GetModalidadesContratos/`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetListMotivosContratoPendente: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Gerador/GetListMotivosContratoPendente/`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetListContratosAtivoPGRS: (pgrs_id = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Gerador/GetListContratosAtivoPGRS/${pgrs_id}`)
            .then(result => resolve(result))
            .catch(result => reject(result))
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            const session = getSessionCookie();
            let modulo = session.acesso.modulo == "Gestor" ? session.acesso.modulo : "CadastroCompleto";

            api_GET(`Gerador/${modulo}/GetItem/${id}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GetItemPGRS: (pgrs_id = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Gerador/GetItemPGRS/${pgrs_id}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GetItemByCpfCnpj: (cpfcnpj) => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Gerador/GetItemByCpfCnpj/${cpfcnpj}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GetPermissaoAlteracaoPGRSGerador: (PGRSGerador_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Gerador/GetPermissaoAlteracaoPGRSGerador/${PGRSGerador_Id}`)
                .then(result => {
                    resolve(result);
                }).catch(e => {
                    reject(e);
                });
        });
        return promise;
    },
    Post: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_Unauthorize(`Gerador`, model).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    Put: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Gerador`, model).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    PostDocumentos: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_files_Unauthorize("Gerador/InsertDocumentosGerador", obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    // CE-4307: TR (com vínculo no endereço) ou Gestor alterna o endereço entre Ativo e Inativo
    PutStatusLocalidade: (body) => {
        return new Promise((resolve, reject) => {
            api_PUT("Gerador/Transportador/AlterarStatusLocalidade", body)
                .then(result => resolve(result))
                .catch(e => reject(e));
        });
    },
    PostAnaliseLocalidade: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Gerador/AnaliseLocalidade", obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    PostAnalisePermissaoCadastroContrato: (obj, PGRS) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Gerador/AnalisePermissaoCadastroContrato/${PGRS}`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetAnaliseLocalidade: (localidade_id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Gerador/AnaliseLocalidade/${localidade_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetListLocalidadesByGerador: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Gerador/GetListLocalidadesByGerador`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetAnaliseLocalidadeGerador: (tbGerador_id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Gerador/AnaliseLocalidadeGerador/${tbGerador_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
}

export default gerador_api;
